import React, { useState, useContext } from "react";
import {
  Col,
  Card,
  Image,
  Form,
  Badge,
  Dropdown,
  ButtonGroup,
} from "react-bootstrap";
import countries from "../../agent_settings/business_info/countries.json";
import { toast } from "react-toastify";
import { GuidedSetupBusinessContext } from "../../../context/GuidedSetupBusinessContext";
import {
  timezones,
  timezoneOffsets,
} from "../../agent_settings/business_info/business_hours";

const GuidedSetupBusinessInfo = () => {
  const { guidedSetupBusinessData, updateBusinessData } = useContext(
    GuidedSetupBusinessContext
  );
  const [inputValue, setInputValue] = useState("");
  const [timezone, setTimezone] = useState(
    guidedSetupBusinessData?.timezone || ""
  );
  // Handle keypress to add services
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim()) {
      event.preventDefault();
      updateBusinessData({
        ...guidedSetupBusinessData,
        coreServices: [
          ...guidedSetupBusinessData.coreServices,
          inputValue.trim(),
        ],
      });
      setInputValue("");
    } else if (event.key === "Backspace" && inputValue === "") {
      // Remove last service when backspace is pressed in empty input
      updateBusinessData({
        ...guidedSetupBusinessData,
        coreServices: guidedSetupBusinessData.coreServices.slice(0, -1),
      });
    }
  };

  const times = [
    "09:00AM",
    "10:00AM",
    "11:00AM",
    "12:00PM",
    "01:00PM",
    "02:00PM",
    "03:00PM",
    "04:00PM",
    "05:00PM",
    "05:30PM",
  ];

  const handleToggle = (index) => {
    const updatedHours = [...guidedSetupBusinessData?.businessHours];
    updatedHours[index].open = !updatedHours[index].open;
    if (!updatedHours[index].open) {
      updatedHours[index].from = "";
      updatedHours[index].to = "";
    } else {
      updatedHours[index].from = "09:00AM";
      updatedHours[index].to = "05:00PM";
    }
    updateBusinessData({
      ...guidedSetupBusinessData,
      businessHours: updatedHours,
    });
  };

  const convertTo24HourFormat = (time) => {
    const [hour, minutePart] = time.slice(0, -2).split(":");
    const period = time.slice(-2);
    let hours = parseInt(hour, 10);
    const minutes = parseInt(minutePart || "00", 10);

    if (period === "PM" && hours !== 12) {
      hours += 12;
    } else if (period === "AM" && hours === 12) {
      hours = 0;
    }

    return hours * 60 + minutes; // Convert to total minutes for easy comparison
  };

  const handleTimeChange = (index, field, value) => {
    const updatedHours = [...guidedSetupBusinessData?.businessHours];
    updatedHours[index][field] = value;

    const fromMinutes = convertTo24HourFormat(updatedHours[index].from);
    const toMinutes = convertTo24HourFormat(updatedHours[index].to);

    if (fromMinutes >= toMinutes) {
      toast.error("From time must be less than To time", {
        position: "top-right",
        autoClose: 1000,
      });
      return;
    }

    updateBusinessData({
      ...guidedSetupBusinessData,
      businessHours: updatedHours,
    });
  };
  const handleTimezoneChange = (tz) => {
    setTimezone(tz);
    updateBusinessData({
      ...guidedSetupBusinessData,
      timezone: tz,
    });
  };
  return (
    <div className="step-content">
      <div className="mb-3">
        <p className="mb-0 black-color fs-two fw-bold">
          Train Nouraa on your business information.
        </p>
        <p className="mb-0 gray-color fs-6">
          This gives Nouraa the context to handle your calls
        </p>
      </div>
      <Col className="mb-4">
        <Card className="business_details_border">
          <Card.Header className="px-4 body-font fw-bold fs-two d-flex justify-content-between business_info_card_header">
            <div className="d-flex black-color" style={{ gap: "12px" }}>
              <Image src="/assets/business-card.svg" alt="Business Details" />
              Business Details
            </div>
          </Card.Header>

          <Card.Body className="p-4 d-flex flex-column gap-4 black-color">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label
                  className="fs-four fw-medium"
                  style={{ color: "#414651", marginBottom: "6px" }}
                >
                  Business Name
                </Form.Label>

                <Form.Control
                  type="text"
                  value={guidedSetupBusinessData.name}
                  onChange={(e) =>
                    updateBusinessData({
                      ...guidedSetupBusinessData,
                      name: e.target.value,
                    })
                  }
                  className="black-color fs-6 fw-normal rounded-3"
                  style={{ borderColor: "#D5D7DA", padding: "9px 14px" }}
                  placeholder="Business Name"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label
                  className="fs-four fw-medium"
                  style={{ color: "#414651", marginBottom: "6px" }}
                >
                  Business Website
                </Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    value={guidedSetupBusinessData.website}
                    onChange={(e) =>
                      updateBusinessData({
                        ...guidedSetupBusinessData,
                        website: e.target.value,
                      })
                    }
                    className="black-color fs-6 fw-normal rounded-3"
                    style={{
                      borderColor: "#D5D7DA",
                      padding: "9px 14px 9px 42px",
                    }}
                    placeholder="Business Website"
                  />
                  <Image
                    src="/assets/globe-gray.svg"
                    alt="Website"
                    className="position-absolute"
                    style={{
                      left: "14px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label
                  className="fs-four fw-medium"
                  style={{ color: "#414651", marginBottom: "6px" }}
                >
                  Address
                </Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    value={guidedSetupBusinessData.address}
                    onChange={(e) =>
                      updateBusinessData({
                        ...guidedSetupBusinessData,
                        address: e.target.value,
                      })
                    }
                    className="black-color fs-6 fw-normal rounded-3"
                    style={{
                      borderColor: "#D5D7DA",
                      padding: "9px 14px 9px 42px",
                    }}
                    placeholder="Address"
                  />
                  <Image
                    src="/assets/map-pin-gray.svg"
                    alt="Website"
                    className="position-absolute"
                    style={{
                      left: "14px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label
                  className="fs-four fw-medium"
                  style={{ color: "#414651", marginBottom: "6px" }}
                >
                  Country{" "}
                </Form.Label>
                <Form.Select
                  value={guidedSetupBusinessData.country}
                  onChange={(e) =>
                    updateBusinessData({
                      ...guidedSetupBusinessData,
                      country: e.target.value,
                    })
                  }
                  className={`fs-6 fw-normal rounded-3 ${
                    !guidedSetupBusinessData.country
                      ? "gray-color italic"
                      : "black-color "
                  }`}
                  style={{ borderColor: "#D5D7DA", padding: "9px 14px" }}
                >
                  <option value="" style={{ color: "gray-color" }}>
                    Select Country
                  </option>
                  {countries.map((country) => (
                    <option
                      key={country.country_id}
                      value={country.country_name}
                    >
                      {country.country_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label
                  className="fs-four fw-medium"
                  style={{ color: "#414651", marginBottom: "6px" }}
                >
                  Business Overview
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={guidedSetupBusinessData.overview}
                  onChange={(e) =>
                    updateBusinessData({
                      ...guidedSetupBusinessData,
                      overview: e.target.value,
                    })
                  }
                  className="black-color fs-6 fw-normal rounded-3"
                  style={{ borderColor: "#D5D7DA", padding: "9px 14px" }}
                  placeholder="Enter a description..."
                />
              </Form.Group>
            </Form>
          </Card.Body>
        </Card>
      </Col>
      <Col className="mb-4">
        <Card className="business_details_border">
          <Card.Header className="px-4 body-font fw-bold fs-two d-flex justify-content-between business_info_card_header">
            <div className="d-flex black-color" style={{ gap: "12px" }}>
              <Image
                src="/assets/material-symbols_business-center-outline.svg"
                alt="Core Services"
              />
              Core Services
            </div>
          </Card.Header>

          <Card.Body className="p-4 d-flex flex-column flex-wrap gap-2">
            <p className="mb-1 fs-four" style={{ color: "#414651" }}>
              Type and hit “Enter” to add new services.
            </p>
            <div
              style={{
                borderColor: "#D5D7DA",
                padding: "10px 14px",
                marginBottom: "1rem",
              }}
              className="border  rounded d-flex flex-wrap align-items-center gap-2"
            >
              {guidedSetupBusinessData?.coreServices.map((service, index) => (
                <Badge
                  key={index}
                  pill
                  bg="light"
                  text="dark"
                  className="px-3 py-2 fw-medium fs-four core_services_badge text-truncate"
                  style={{ marginBottom: "7px" }}
                >
                  {service}
                </Badge>
              ))}
              <Form.Control
                type="text"
                placeholder="Add a service..."
                className="border-0 shadow-none"
                style={{ outline: "none", width: "auto", flexGrow: 1 }}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card className="business_details_border">
          <Card.Header className="px-4 body-font fw-bold fs-two d-flex justify-content-between business_info_card_header">
            <div className="d-flex black-color" style={{ gap: "12px" }}>
              <Image src="/assets/clock-colored.svg" alt="Business Hours" />
              Business Hours
            </div>
          </Card.Header>
          <Card.Body className="p-4 d-flex flex-column fs-four black-color">
            <Form.Group className="mb-4 guided-setup-timezone">
              <Form.Label
                className="fs-four fw-medium"
                style={{ color: "#414651" }}
              >
                Timezone
              </Form.Label>
              <Form.Select
                value={timezone}
                onChange={(e) => handleTimezoneChange(e.target.value)}
                className="w-100 text-start business-hrs-dropdown black-color fs-6"
                style={{ borderColor: "#D5D7DA" }}
              >
                <option value="" disabled>
                  Select Timezone
                </option>
                {timezones.map((tz, idx) => (
                  <option key={idx} value={tz.tzCode}>
                    {timezoneOffsets[tz.tzCode] || ""} {tz.tzCode}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <div
              className="mb-4"
              style={{ borderBottom: "1px solid #d5d7da" }}
            ></div>

            {guidedSetupBusinessData?.businessHours.map((day, index) => (
              <div
                key={index}
                className="mb-4 gap-2 gap-lg-0 align-items-center d-flex flex-column flex-lg-row"
              >
                <div className="d-flex align-items-center guided-setup-business-hrs-toggle">
                  <Form.Check
                    type="switch"
                    id={`switch-${index}`}
                    checked={day.open}
                    onChange={() => handleToggle(index)}
                    className="custom-switch"
                  />
                  <span className="fs-6 fw-medium black-color">{day.day}</span>
                </div>
                {day.open ? (
                  <div className="ps-lg-5 ps-0 d-flex gap-4 justify-content-between flex-lg-row flex-column w-lg-70 w-100">
                    <div className="d-flex align-items-center border rounded pe-0 business-hrs-time-dropdown">
                      <span
                        className="fs-6 business-hrs-timeselection"
                        style={{ maxWidth: "55px" }}
                      >
                        From
                      </span>
                      <span className="vr" />

                      <Dropdown as={ButtonGroup} className="w-100 border-0">
                        <Dropdown.Toggle
                          variant="outline-primary"
                          className="black-color w-100 text-start border-0 business-hrs-dropdown fs-6"
                        >
                          {day.from}
                          <Image
                            src="/assets/chevron-down.svg"
                            alt="Arrow Down"
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {times.map((time, idx) => (
                            <Dropdown.Item
                              key={idx}
                              onClick={() =>
                                handleTimeChange(index, "from", time)
                              }
                              active={day.from === time}
                              style={{
                                backgroundColor:
                                  day.from === time ? "#5925dc" : "transparent", // Blue when selected
                                color: day.from === time ? "white" : "#181D27", // White text for selected
                              }}
                            >
                              {time}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="d-flex align-items-center border rounded pe-0 business-hrs-time-dropdown">
                      <span
                        className="fs-6 business-hrs-timeselection"
                        style={{ maxWidth: "55px" }}
                      >
                        To
                      </span>
                      <span className="vr" />

                      <Dropdown as={ButtonGroup} className="w-100 border-0">
                        <Dropdown.Toggle
                          variant="outline-primary"
                          className="black-color w-100 text-start border-0 business-hrs-dropdown fs-6"
                        >
                          {day.to}
                          <Image
                            src="/assets/chevron-down.svg"
                            alt="Arrow Down"
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {times.map((time, idx) => (
                            <Dropdown.Item
                              key={idx}
                              onClick={() =>
                                handleTimeChange(index, "to", time)
                              }
                              active={day.to === time}
                              style={{
                                backgroundColor:
                                  day.to === time ? "#5925dc" : "transparent", // Blue when selected
                                color: day.to === time ? "white" : "#181D27", // White text for selected
                              }}
                            >
                              {time}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex fs-6 fw-normal gap-2 border rounded w-100 guided-setup-closed">
                    <Image src="/assets/moon.svg" /> Closed
                  </div>
                )}
              </div>
            ))}
          </Card.Body>
        </Card>
      </Col>
    </div>
  );
};

export default GuidedSetupBusinessInfo;
